export default "__VITE_ASSET__DlB0Gadz__"